// Whether this session is an assistant's visit to a participant's account (fullstack ROADMAP.md
// § Assistant account access): the server marks the session the assistant opened it with
// (publicMetadata.assistantVisits, api/v1/user/assistant/visit). The banner (Dialog/
// AssistantBanner.vue) and the Profile's email editor (Profile/Email.vue) follow it: a courtesy,
// not a guard.

import {computed} from "vue";
import useUserSafe from "@/composables/useUserSafe";

export function useAssistantVisit() {
  const {user} = useUserSafe();
  const isVisit = computed(() => {
    const sessionId = user.value ? window.Clerk?.session?.id : "";
    const visits = user.value?.publicMetadata?.assistantVisits || [];
    return Boolean(sessionId) && visits.some((visit) => visit.sessionId === sessionId);
  });
  const name = computed(() => {
    const parts = [user.value?.firstName, user.value?.lastName].filter(Boolean);
    return parts.join(" ") || user.value?.primaryEmailAddress?.emailAddress || "this person";
  });
  return {isVisit, name};
}
